import { IconEdit } from './ScanIcons'

function ProductGlyph() {
  return (
    <svg viewBox="0 0 24 24" width="36" height="36" aria-hidden="true" focusable="false">
      <path d="M8.2 7.2 9.6 5.6h4.8l1.4 1.6H19a2 2 0 0 1 2 2v8.2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9.2a2 2 0 0 1 2-2h3.2Z" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <circle cx="12" cy="13" r="2.6" fill="none" stroke="currentColor" strokeWidth="1.6" />
    </svg>
  )
}

function CheckGlyph() {
  return (
    <svg viewBox="0 0 16 16" width="10" height="10" aria-hidden="true" focusable="false">
      <path d="M3.4 8.2 6.3 11l6.3-6.8" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

const PHASES = [
  { id: 'analyse', label: 'analyse' },
  { id: 'identification', label: 'identification' },
  { id: 'preparation', label: 'préparation' },
]

const PHASE_ORDER = { analyse: 0, identification: 1, preparation: 2 }

export default function ScanAnalyzeSheet({
  statusText,
  phase = 'analyse',
  previewUrl,
  onClose,
  onManual,
}) {
  const activeIndex = PHASE_ORDER[phase] ?? 0

  return (
    <div className="scan-analyze">
      <header className="scan-analyze-header">
        <h2 id="scan-product-title">Analyse</h2>
        <button type="button" className="scan-icon-btn" onClick={onClose} aria-label="Fermer">
          <span aria-hidden="true">✕</span>
        </button>
      </header>
      <div className="scan-analyze-body">
        <div className="scan-analyze-stage" aria-hidden="true">
          <div className="scan-analyze-orbit">
            <div className="scan-analyze-card">
              <div className="scan-analyze-layer scan-analyze-layer--back" />
              <div className="scan-analyze-layer scan-analyze-layer--mid" />
              <div className="scan-analyze-thumb">
                {previewUrl ? <img src={previewUrl} alt="" /> : <ProductGlyph />}
                <span className="scan-analyze-beam" />
              </div>
              <div className="scan-analyze-ring" />
            </div>
          </div>
        </div>
        <p className="scan-analyze-status" role="status" aria-live="polite">
          {statusText || 'Analyse de la photographie…'}
        </p>
        <ol className="scan-analyze-phases">
          {PHASES.map((item, index) => {
            const done = index < activeIndex
            const active = index === activeIndex
            return (
              <li
                key={item.id}
                className={`scan-analyze-phase${done ? ' is-done' : ''}${active ? ' is-active' : ''}`}
              >
                <span className="scan-analyze-dot">
                  {done ? <CheckGlyph /> : null}
                </span>
                <span>{item.label}</span>
              </li>
            )
          })}
        </ol>
        <button type="button" className="scan-ghost scan-analyze-manual" onClick={onManual}>
          <span className="scan-manual-shine" aria-hidden="true" />
          <IconEdit />
          <span>Saisie manuelle</span>
        </button>
      </div>
    </div>
  )
}
